/**
    * A function that is triggered to refresh the calculator of total time, fine and points.
    * @param chargesCalculator `object[]` - The current charges that are pending to be pressed.
    * @param violationCalculator `object[]` - The current violations (tickets) that are pending to be issued.
    * @param setTotalFine `Function` - The state update function for total fine.
    * @param setTotalTime `Function` - The state update function for total time.
    * @param setTotalPoints `Function` - The state update function for total points.
    * @param setChargesString `Function` - The state update function for the command strings.
    * @returns `void` - This returns nothing.
*/
export const RefreshCalculator = (
    chargesCalculator: object[],
    violationCalculator: object[],
    setTotalFine: Function,
    setTotalTime: Function,
    setTotalPoints: Function,
    setChargesString: Function
) => {
    let newTotalFine = 0;
    let newTotalTime = 0;
    let newTotalPoints = 0;

    // ITERATE THROUGH CHARGES
    const chargeNameCache: any = {};
    chargesCalculator.map((chargeData: any) => {
        newTotalFine += chargeData.fine;
        newTotalTime += chargeData.months;

        // FORMAT CHARGES STRING FOR COMMANDS
        const chargeDisplayName = `[${chargeData.section}] ${chargeData.name}`;
        if (!chargeNameCache[chargeDisplayName]) {
            chargeNameCache[chargeDisplayName] = 1
        } else {
            chargeNameCache[chargeDisplayName]++;
        }
    });

    // ITERATE THROUGH VIOLATIONS
    violationCalculator.map((violationData: any) => {
        newTotalFine += violationData.fine;
        newTotalPoints += violationData.points;

        // FORMAT CHARGES STRING FOR COMMANDS
        const chargeDisplayName = `[${violationData.section}] ${violationData.name}`;
        if (!chargeNameCache[chargeDisplayName]) {
            chargeNameCache[chargeDisplayName] = 1
        } else {
            chargeNameCache[chargeDisplayName]++;
        }
    });

    // FINALIZE CHARGES STRING FOR COMMANDS
    let newChargesString = '';
    for (const [chargeName, amountOfCharges] of Object.entries(chargeNameCache)) {
        newChargesString += `${newChargesString !== '' ? ' | ' : ''}${chargeName}${(amountOfCharges as number) > 1 ? (' x' + amountOfCharges) : ''}`
    }

    // UPDATE ALL STATES
    setTotalFine(newTotalFine);
    setTotalTime(newTotalTime);
    setTotalPoints(newTotalPoints);
    setChargesString(newChargesString);
}
